<template>
  <main class="website-main">
    <section class="intro">
      <div>
        <div>
          <img
            src="/images/logo-white.svg"
            alt="logo"
          >
          <strong><span>upraví</span><br><span>pomůže</span><br><span>nahradí</span><br><span>a vyrobí</span></strong>
        </div>
        <div>
          <div>
            <h1>Dílna Zejman</h1>
            <div>
              <a href="#kontakt">Kontaktujte nás</a>
            </div>
          </div>
        </div>
      </div>
      <span class="show-more">
        <a href="#sluzby">Co děláme?</a>
      </span>
    </section>
    <section
      id="sluzby"
      class="services"
    >
      <div>
        <article>
          <h2>Interiér</h2>
          <div>
            <div class="default-text">
              <slot name="interior" />
            </div>
            <div>
              <a href="#kontakt">...a mnohé další!</a>
            </div>
          </div>
          <img
            src="/images/jiskry.avif"
            alt="jiskry"
          >
        </article>
        <article>
          <h2>Exteriér</h2>
          <div>
            <div class="default-text">
              <slot name="exterior" />
            </div>
            <div>
              <a href="#kontakt">...a mnohé další!</a>
            </div>
          </div>
          <img
            src="/images/plot.avif"
            alt="jiskry"
          >
        </article>
      </div>
    </section>
    <section
      id="spoluprace"
      class="cooperation"
    >
      <div>
        <article class="tiles why-us">
          <h2>Proč zrovna my?</h2>
          <div class="flip-card">
            <div>
              <div class="flip-card-front">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 448 512"
                  fill="currentColor"
                >
                  <path d="M216 0l16 0c13.3 0 24 10.7 24 24l0 56 28.4-56.9c38 20.4 64.5 59.4 67.3 104.9l.2 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L96 176c-13.3 0-24-10.7-24-24s10.7-24 24-24l.2 0C99 82.6 125.6 43.5 163.6 23.1L192 80l0-56c0-13.3 10.7-24 24-24zM162 304c-34.9-19.4-59.8-54.6-65-96l48.6 0c7.4 36.5 39.7 64 78.4 64s71-27.5 78.4-64l48.6 0c-5.2 41.4-30.1 76.6-65 96c-18.4 10.2-39.5 16-62 16s-43.6-5.8-62-16zm-11.4 48l73.4 0 73.4 0 16.2 0C387.8 352 448 412.2 448 486.4c0 14.1-11.5 25.6-25.6 25.6L25.6 512C11.5 512 0 500.5 0 486.4C0 412.2 60.2 352 134.4 352l16.2 0zM397.1 464c-9.9-36.9-43.5-64-83.5-64l-179.2 0c-40 0-73.6 27.1-83.5 64l346.1 0z" />
                </svg>
                <h3>profesionalita</h3>
              </div>
              <div class="flip-card-back">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 448 512"
                  fill="currentColor"
                >
                  <path d="M216 0l16 0c13.3 0 24 10.7 24 24l0 56 28.4-56.9c38 20.4 64.5 59.4 67.3 104.9l.2 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L96 176c-13.3 0-24-10.7-24-24s10.7-24 24-24l.2 0C99 82.6 125.6 43.5 163.6 23.1L192 80l0-56c0-13.3 10.7-24 24-24zM162 304c-34.9-19.4-59.8-54.6-65-96l48.6 0c7.4 36.5 39.7 64 78.4 64s71-27.5 78.4-64l48.6 0c-5.2 41.4-30.1 76.6-65 96c-18.4 10.2-39.5 16-62 16s-43.6-5.8-62-16zm-11.4 48l73.4 0 73.4 0 16.2 0C387.8 352 448 412.2 448 486.4c0 14.1-11.5 25.6-25.6 25.6L25.6 512C11.5 512 0 500.5 0 486.4C0 412.2 60.2 352 134.4 352l16.2 0zM397.1 464c-9.9-36.9-43.5-64-83.5-64l-179.2 0c-40 0-73.6 27.1-83.5 64l346.1 0z" />
                </svg>
                <h3>profesionalita</h3>
                <slot name="professionalism" />
              </div>
            </div>
          </div>
          <div class="flip-card">
            <div>
              <div class="flip-card-front">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                  fill="currentColor"
                >
                  <path d="M352.002 0C263.599 0 192 71.603 192 160.002c0 14.702 2.003 28.902 5.699 42.3l-174.5 174.5A79.086 79.086 0 0 0 0 432.8C0 476.503 35.501 512 79.2 512a79.086 79.086 0 0 0 56-23.199l37.671-37.67A113.726 113.726 0 0 0 273.34 512a113.726 113.726 0 0 0 82.053-192.086C442.219 318.107 512 247.264 512 160.002c0-24.801-5.597-48.302-15.7-69.301-4.4-9.2-16.502-10.5-23.698-3.3L404.7 155.304a16.055 16.055 0 0 1-11.3 4.698H368a16.048 16.048 0 0 1-15.998-15.999v-25.402c0-4.199 1.7-8.3 4.698-11.3l67.899-67.9c7.2-7.2 5.903-19.302-3.3-23.697a160.837 160.837 0 0 0-69.297-15.7Zm-4.003 48.106-25.3 25.202a64.017 64.017 0 0 0-18.697 45.297v25.398c0 35.301 28.698 64.003 63.998 64.003h25.3c17 0 33.298-6.701 45.298-18.701l25.304-25.3c-2.102 60-51.402 108-111.9 108-10.402 0-20.3-1.4-29.7-4a48.125 48.125 0 0 0-46.601 12.397l-4.282 4.286A113.726 113.726 0 0 0 159.885 396.29l-58.583 58.617a31.514 31.514 0 0 1-22.102 9.097c-17.197 0-31.2-14-31.2-31.2 0-8.3 3.201-16.301 9.101-22.099l174.5-174.398c12.2-12.2 17-30.002 12.397-46.602a111.484 111.484 0 0 1-3.999-29.7c0-60.498 48-109.9 108-111.9zM315.98 359.16c2.729 0 5.45 1.043 7.514 3.13 4.135 4.176 4.176 10.93 0 15.06l.045.046-56.863 56.863a10.62 10.62 0 0 1-15.061 0l-28.433-28.433a10.605 10.605 0 0 1-2.045-2.956l14.15-14.154c1.066.51 2.079 1.164 2.956 2.052l20.878 20.878 49.315-49.357a10.643 10.643 0 0 1 7.544-3.129ZM88 408.003a16 16 0 1 0 0 32.001 15.999 15.999 0 1 0 0-31.997z" />
                </svg>
                <h3>spolehlivost</h3>
              </div>
              <div class="flip-card-back">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                  fill="currentColor"
                >
                  <path d="M352.002 0C263.599 0 192 71.603 192 160.002c0 14.702 2.003 28.902 5.699 42.3l-174.5 174.5A79.086 79.086 0 0 0 0 432.8C0 476.503 35.501 512 79.2 512a79.086 79.086 0 0 0 56-23.199l37.671-37.67A113.726 113.726 0 0 0 273.34 512a113.726 113.726 0 0 0 82.053-192.086C442.219 318.107 512 247.264 512 160.002c0-24.801-5.597-48.302-15.7-69.301-4.4-9.2-16.502-10.5-23.698-3.3L404.7 155.304a16.055 16.055 0 0 1-11.3 4.698H368a16.048 16.048 0 0 1-15.998-15.999v-25.402c0-4.199 1.7-8.3 4.698-11.3l67.899-67.9c7.2-7.2 5.903-19.302-3.3-23.697a160.837 160.837 0 0 0-69.297-15.7Zm-4.003 48.106-25.3 25.202a64.017 64.017 0 0 0-18.697 45.297v25.398c0 35.301 28.698 64.003 63.998 64.003h25.3c17 0 33.298-6.701 45.298-18.701l25.304-25.3c-2.102 60-51.402 108-111.9 108-10.402 0-20.3-1.4-29.7-4a48.125 48.125 0 0 0-46.601 12.397l-4.282 4.286A113.726 113.726 0 0 0 159.885 396.29l-58.583 58.617a31.514 31.514 0 0 1-22.102 9.097c-17.197 0-31.2-14-31.2-31.2 0-8.3 3.201-16.301 9.101-22.099l174.5-174.398c12.2-12.2 17-30.002 12.397-46.602a111.484 111.484 0 0 1-3.999-29.7c0-60.498 48-109.9 108-111.9zM315.98 359.16c2.729 0 5.45 1.043 7.514 3.13 4.135 4.176 4.176 10.93 0 15.06l.045.046-56.863 56.863a10.62 10.62 0 0 1-15.061 0l-28.433-28.433a10.605 10.605 0 0 1-2.045-2.956l14.15-14.154c1.066.51 2.079 1.164 2.956 2.052l20.878 20.878 49.315-49.357a10.643 10.643 0 0 1 7.544-3.129ZM88 408.003a16 16 0 1 0 0 32.001 15.999 15.999 0 1 0 0-31.997z" />
                </svg>
                <h3>spolehlivost</h3>
                <slot name="reliability" />
              </div>
            </div>
          </div>
          <div class="flip-card">
            <div>
              <div class="flip-card-front">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 384 512"
                  fill="currentColor"
                >
                  <path d="M163.1 8.1c17.7-10.8 40-10.8 57.8 0l15.6 9.5c1.2 .7 2.7 1.1 4.1 1.1l18.3-.4c20.8-.5 40.1 10.7 50 28.9l8.8 16.1c.7 1.3 1.7 2.3 3 3L336.8 75c18.2 10 29.4 29.3 28.9 50l-.4 18.3c0 1.4 .3 2.9 1.1 4.1l9.5 15.6c10.8 17.7 10.8 40 0 57.8l-9.5 15.6c-.7 1.2-1.1 2.7-1.1 4.1l.4 18.3c.5 20.8-10.7 40.1-28.9 50l-16.1 8.8c-1.3 .7-2.3 1.7-3 3L309 336.8c-10 18.2-29.3 29.4-50 28.9l-18.3-.4c-1.4 0-2.9 .3-4.1 1.1l-15.6 9.5c-17.7 10.8-40 10.8-57.8 0l-15.6-9.5c-1.2-.7-2.7-1.1-4.1-1.1l-18.3 .4c-20.8 .5-40.1-10.7-50-28.9l-8.8-16.1c-.7-1.3-1.7-2.3-3-3L47.2 309c-18.2-10-29.4-29.3-28.9-50l.4-18.3c0-1.4-.3-2.9-1.1-4.1L8.1 220.9c-10.8-17.7-10.8-40 0-57.8l9.5-15.6c.7-1.2 1.1-2.7 1.1-4.1l-.4-18.3C17.8 104.3 29 85 47.2 75l16.1-8.8c1.3-.7 2.3-1.7 3-3L75 47.2c10-18.2 29.3-29.4 50-28.9l18.3 .4c1.4 0 2.9-.3 4.1-1.1l15.6-9.5zm32.8 41c-2.4-1.5-5.4-1.5-7.8 0l-15.6 9.5c-9.1 5.5-19.6 8.3-30.2 8.1l-18.3-.4c-2.8-.1-5.4 1.4-6.8 3.9l-8.8 16.1c-5.1 9.3-12.8 17-22.1 22.1l-16.1 8.8c-2.5 1.4-4 4-3.9 6.8l.4 18.3c.3 10.6-2.6 21.1-8.1 30.2l-9.5 15.6L28.6 175.6l20.5 12.5c-1.5 2.4-1.5 5.4 0 7.8l9.5 15.6c5.5 9.1 8.3 19.6 8.1 30.2l-.4 18.3c-.1 2.8 1.4 5.4 3.9 6.8l16.1 8.8c9.3 5.1 17 12.8 22.1 22.1l8.8 16.1c1.4 2.5 4 4 6.8 3.9l18.3-.4c10.6-.3 21.1 2.6 30.2 8.1l15.6 9.5c2.4 1.5 5.4 1.5 7.8 0l15.6-9.5c9.1-5.5 19.6-8.3 30.2-8.1l18.3 .4c2.8 .1 5.4-1.4 6.8-3.9l8.8-16.1c5.1-9.3 12.8-17 22.1-22.1l16.1-8.8c2.5-1.4 4-4 3.9-6.8l-.4-18.3c-.3-10.6 2.6-21.1 8.1-30.2l9.5-15.6c1.5-2.4 1.5-5.4 0-7.8l-9.5-15.6c-5.5-9.1-8.3-19.6-8.1-30.2l.4-18.3c.1-2.8-1.4-5.4-3.9-6.8l-16.1-8.8c-9.3-5.1-17-12.8-22.1-22.1l-8.8-16.1c-1.4-2.5-4-4-6.8-3.9l-18.3 .4c-10.6 .3-21.1-2.6-30.2-8.1l-15.6-9.5zM128 192a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM1.3 441.8l41.2-97.9 4.5 8.2c15.7 28.7 46.1 46.3 78.9 45.5l11.1-.3 9.5 5.8c8 4.9 16.7 8.4 25.6 10.5l-37.3 88.5c-2.3 5.5-7.4 9.2-13.3 9.7s-11.6-2.2-14.8-7.2L74.4 455.5l-56.1 8.3c-5.7 .8-11.4-1.5-15-6s-4.3-10.7-2.1-16zm248 60.4L212 413.7c8.9-2.1 17.5-5.6 25.5-10.5l9.5-5.8 11.1 .3c32.7 .8 63.2-16.8 78.9-45.5l4.5-8.2 41.2 97.9c2.2 5.3 1.4 11.4-2.1 16s-9.3 6.9-15 6l-56.1-8.3-32.2 49.2c-3.2 5-8.9 7.7-14.8 7.2s-11-4.3-13.3-9.7z" />
                </svg>
                <h3>kvalita</h3>
              </div>
              <div class="flip-card-back">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 384 512"
                  fill="currentColor"
                >
                  <path d="M163.1 8.1c17.7-10.8 40-10.8 57.8 0l15.6 9.5c1.2 .7 2.7 1.1 4.1 1.1l18.3-.4c20.8-.5 40.1 10.7 50 28.9l8.8 16.1c.7 1.3 1.7 2.3 3 3L336.8 75c18.2 10 29.4 29.3 28.9 50l-.4 18.3c0 1.4 .3 2.9 1.1 4.1l9.5 15.6c10.8 17.7 10.8 40 0 57.8l-9.5 15.6c-.7 1.2-1.1 2.7-1.1 4.1l.4 18.3c.5 20.8-10.7 40.1-28.9 50l-16.1 8.8c-1.3 .7-2.3 1.7-3 3L309 336.8c-10 18.2-29.3 29.4-50 28.9l-18.3-.4c-1.4 0-2.9 .3-4.1 1.1l-15.6 9.5c-17.7 10.8-40 10.8-57.8 0l-15.6-9.5c-1.2-.7-2.7-1.1-4.1-1.1l-18.3 .4c-20.8 .5-40.1-10.7-50-28.9l-8.8-16.1c-.7-1.3-1.7-2.3-3-3L47.2 309c-18.2-10-29.4-29.3-28.9-50l.4-18.3c0-1.4-.3-2.9-1.1-4.1L8.1 220.9c-10.8-17.7-10.8-40 0-57.8l9.5-15.6c.7-1.2 1.1-2.7 1.1-4.1l-.4-18.3C17.8 104.3 29 85 47.2 75l16.1-8.8c1.3-.7 2.3-1.7 3-3L75 47.2c10-18.2 29.3-29.4 50-28.9l18.3 .4c1.4 0 2.9-.3 4.1-1.1l15.6-9.5zm32.8 41c-2.4-1.5-5.4-1.5-7.8 0l-15.6 9.5c-9.1 5.5-19.6 8.3-30.2 8.1l-18.3-.4c-2.8-.1-5.4 1.4-6.8 3.9l-8.8 16.1c-5.1 9.3-12.8 17-22.1 22.1l-16.1 8.8c-2.5 1.4-4 4-3.9 6.8l.4 18.3c.3 10.6-2.6 21.1-8.1 30.2l-9.5 15.6L28.6 175.6l20.5 12.5c-1.5 2.4-1.5 5.4 0 7.8l9.5 15.6c5.5 9.1 8.3 19.6 8.1 30.2l-.4 18.3c-.1 2.8 1.4 5.4 3.9 6.8l16.1 8.8c9.3 5.1 17 12.8 22.1 22.1l8.8 16.1c1.4 2.5 4 4 6.8 3.9l18.3-.4c10.6-.3 21.1 2.6 30.2 8.1l15.6 9.5c2.4 1.5 5.4 1.5 7.8 0l15.6-9.5c9.1-5.5 19.6-8.3 30.2-8.1l18.3 .4c2.8 .1 5.4-1.4 6.8-3.9l8.8-16.1c5.1-9.3 12.8-17 22.1-22.1l16.1-8.8c2.5-1.4 4-4 3.9-6.8l-.4-18.3c-.3-10.6 2.6-21.1 8.1-30.2l9.5-15.6c1.5-2.4 1.5-5.4 0-7.8l-9.5-15.6c-5.5-9.1-8.3-19.6-8.1-30.2l.4-18.3c.1-2.8-1.4-5.4-3.9-6.8l-16.1-8.8c-9.3-5.1-17-12.8-22.1-22.1l-8.8-16.1c-1.4-2.5-4-4-6.8-3.9l-18.3 .4c-10.6 .3-21.1-2.6-30.2-8.1l-15.6-9.5zM128 192a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM1.3 441.8l41.2-97.9 4.5 8.2c15.7 28.7 46.1 46.3 78.9 45.5l11.1-.3 9.5 5.8c8 4.9 16.7 8.4 25.6 10.5l-37.3 88.5c-2.3 5.5-7.4 9.2-13.3 9.7s-11.6-2.2-14.8-7.2L74.4 455.5l-56.1 8.3c-5.7 .8-11.4-1.5-15-6s-4.3-10.7-2.1-16zm248 60.4L212 413.7c8.9-2.1 17.5-5.6 25.5-10.5l9.5-5.8 11.1 .3c32.7 .8 63.2-16.8 78.9-45.5l4.5-8.2 41.2 97.9c2.2 5.3 1.4 11.4-2.1 16s-9.3 6.9-15 6l-56.1-8.3-32.2 49.2c-3.2 5-8.9 7.7-14.8 7.2s-11-4.3-13.3-9.7z" />
                </svg>
                <h3>kvalita</h3>
                <slot name="quality" />
              </div>
            </div>
          </div>
        </article>
        <h2>Spolupráce</h2>
        <article class="tiles coop">
          <div class="flip-card">
            <div>
              <div class="flip-card-front">
                <h3>soukromé osoby</h3>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 448 512"
                  fill="currentColor"
                >
                  <path d="M304 128a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM49.3 464l349.5 0c-8.9-63.3-63.3-112-129-112l-91.4 0c-65.7 0-120.1 48.7-129 112zM0 482.3C0 383.8 79.8 304 178.3 304l91.4 0C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3z" />
                </svg>
              </div>
              <div class="flip-card-back">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 448 512"
                  fill="currentColor"
                >
                  <path d="M304 128a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM49.3 464l349.5 0c-8.9-63.3-63.3-112-129-112l-91.4 0c-65.7 0-120.1 48.7-129 112zM0 482.3C0 383.8 79.8 304 178.3 304l91.4 0C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3z" />
                </svg>
                <h3>soukromé osoby</h3>
                <slot name="private-persons" />
              </div>
            </div>
          </div>
          <div class="flip-card">
            <div>
              <div class="flip-card-front">
                <h3>sdružení a&nbsp;družstva</h3>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 640 512"
                  fill="currentColor"
                >
                  <path d="M352 48l224 0c8.8 0 16 7.2 16 16l0 384c0 8.8-7.2 16-16 16l-160 0c0 18-6 34.6-16 48l176 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L352 0c-35.3 0-64 28.7-64 64l0 60.6 48 44L336 64c0-8.8 7.2-16 16-16zm61.2 208l18.8 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 4.6 6.1 5.6c11.2 10.3 19.2 23.4 23.1 37.9zm2.8 96l16 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-16 0 0 64zm64-144l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM400 96c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm80 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM20.8 237C7.5 249.1 0 266.2 0 284.2L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-163.8c0-17.9-7.5-35.1-20.8-47.2l-128-117.3c-24.5-22.4-62-22.4-86.5 0L20.8 237zM48 284.2c0-4.5 1.9-8.8 5.2-11.8L181.2 155c6.1-5.6 15.5-5.6 21.6 0l128 117.3c3.3 3 5.2 7.3 5.2 11.8L336 448c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-163.8zM144 296l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24z" />
                </svg>
              </div>
              <div class="flip-card-back">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 640 512"
                  fill="currentColor"
                >
                  <path d="M352 48l224 0c8.8 0 16 7.2 16 16l0 384c0 8.8-7.2 16-16 16l-160 0c0 18-6 34.6-16 48l176 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L352 0c-35.3 0-64 28.7-64 64l0 60.6 48 44L336 64c0-8.8 7.2-16 16-16zm61.2 208l18.8 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 4.6 6.1 5.6c11.2 10.3 19.2 23.4 23.1 37.9zm2.8 96l16 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-16 0 0 64zm64-144l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM400 96c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm80 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM20.8 237C7.5 249.1 0 266.2 0 284.2L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-163.8c0-17.9-7.5-35.1-20.8-47.2l-128-117.3c-24.5-22.4-62-22.4-86.5 0L20.8 237zM48 284.2c0-4.5 1.9-8.8 5.2-11.8L181.2 155c6.1-5.6 15.5-5.6 21.6 0l128 117.3c3.3 3 5.2 7.3 5.2 11.8L336 448c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-163.8zM144 296l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24z" />
                </svg>
                <h3>sdružení a&nbsp;družstva</h3>
                <slot name="associations-and-cooperatives" />
              </div>
            </div>
          </div>
          <div class="flip-card">
            <div>
              <div class="flip-card-front">
                <h3>podnikatelé a&nbsp;firmy</h3>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 719 512"
                  fill="currentColor"
                >
                  <path d="M288 0c-35.3 0-64 28.7-64 64v384c0 35.3 28.7 64 64 64h410.9c11.12 0 20.08-9.027 20.08-20.08 0-49.381-33.944-90.847-79.728-102.293-5.298-1.308-10.4 2.158-11.709 7.39l-23.545 96.08-21.78-81.036 12.165-20.276c4.186-6.998-.85-15.828-8.961-15.828h-25.834c-8.11 0-13.147 8.895-8.961 15.828h-.064l12.164 20.276-21.78 81.037-23.547-96.08c-.756-3.065-2.801-5.478-5.4-6.735V318.52a83.719 83.719 0 0 0 144.191-57.676A83.719 83.719 0 0 0 512 203.166V64c0-35.3-28.7-64-64-64H288zm0 48h160c8.8 0 16 7.2 16 16v346.928c-16.315 13.6-28.48 31.995-34.256 53.072H288c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16zm64 48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32zM72 128c-39.8 0-72 32.2-72 72v240c0 39.8 32.2 72 72 72h144.4c-11.8-13.2-20.1-29.7-23.1-48H72c-13.3 0-24-10.7-24-24V200c0-13.3 10.7-24 24-24h120v-48H72zm280 64c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32zm-240 32c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32zm240 64c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32zm-240 32c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32z" />
                </svg>
              </div>
              <div class="flip-card-back">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 719 512"
                  fill="currentColor"
                >
                  <path d="M288 0c-35.3 0-64 28.7-64 64v384c0 35.3 28.7 64 64 64h410.9c11.12 0 20.08-9.027 20.08-20.08 0-49.381-33.944-90.847-79.728-102.293-5.298-1.308-10.4 2.158-11.709 7.39l-23.545 96.08-21.78-81.036 12.165-20.276c4.186-6.998-.85-15.828-8.961-15.828h-25.834c-8.11 0-13.147 8.895-8.961 15.828h-.064l12.164 20.276-21.78 81.037-23.547-96.08c-.756-3.065-2.801-5.478-5.4-6.735V318.52a83.719 83.719 0 0 0 144.191-57.676A83.719 83.719 0 0 0 512 203.166V64c0-35.3-28.7-64-64-64H288zm0 48h160c8.8 0 16 7.2 16 16v346.928c-16.315 13.6-28.48 31.995-34.256 53.072H288c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16zm64 48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32zM72 128c-39.8 0-72 32.2-72 72v240c0 39.8 32.2 72 72 72h144.4c-11.8-13.2-20.1-29.7-23.1-48H72c-13.3 0-24-10.7-24-24V200c0-13.3 10.7-24 24-24h120v-48H72zm280 64c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32zm-240 32c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32zm240 64c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32zm-240 32c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32z" />
                </svg>
                <h3>podnikatelé a&nbsp;firmy</h3>
                <slot name="entrepreneurs-and-companies" />
              </div>
            </div>
          </div>
          <div class="flip-card">
            <div>
              <div class="flip-card-front">
                <h3>statutární orgány</h3>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                  fill="currentColor"
                >
                  <path d="M267.6 3c-7.2-4-16-4-23.2 0L17.6 128.1C6.7 134.1 0 145.5 0 157.9C0 176.8 15.2 192 34.1 192l443.9 0c18.8 0 34.1-15.2 34.1-34.1c0-12.4-6.7-23.8-17.6-29.8L267.6 3zM228.3 144L88.2 144 256 51.4 423.8 144l-140.1 0c2.7-4.7 4.3-10.2 4.3-16c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 5.8 1.6 11.3 4.3 16zM64 224l0 160c-13.3 0-24 10.7-24 24s10.7 24 24 24l392 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-160-48 0 0 160-64 0 0-160-48 0 0 160-64 0 0-160-48 0 0 160-64 0 0-160-48 0zM32 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l456 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L32 464z" />
                </svg>
              </div>
              <div class="flip-card-back">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                  fill="currentColor"
                >
                  <path d="M267.6 3c-7.2-4-16-4-23.2 0L17.6 128.1C6.7 134.1 0 145.5 0 157.9C0 176.8 15.2 192 34.1 192l443.9 0c18.8 0 34.1-15.2 34.1-34.1c0-12.4-6.7-23.8-17.6-29.8L267.6 3zM228.3 144L88.2 144 256 51.4 423.8 144l-140.1 0c2.7-4.7 4.3-10.2 4.3-16c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 5.8 1.6 11.3 4.3 16zM64 224l0 160c-13.3 0-24 10.7-24 24s10.7 24 24 24l392 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-160-48 0 0 160-64 0 0-160-48 0 0 160-64 0 0-160-48 0 0 160-64 0 0-160-48 0zM32 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l456 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L32 464z" />
                </svg>
                <h3>statutární orgány</h3>
                <slot name="statutory-bodies" />
              </div>
            </div>
          </div>
        </article>
      </div>
    </section>
    <v-section-reference :galleries="galleries">
      <template #about>
        <slot name="about" />
      </template>
    </v-section-reference>
    <section
      id="kontakt"
      class="contact"
    >
      <div>
        <h2>Kontakt</h2>
        <div>
          <v-dialog
            v-model="successDialog"
            max-width="320"
          >
            <v-card>
              <p class="text-center pa-4">
                Kontaktní formulář byl úspěšně odeslán.
              </p>
              <v-btn
                type="submit"
                variant="flat"
                @click="successDialog = false"
              >
                Pokračovat
              </v-btn>
            </v-card>
          </v-dialog>

          <v-dialog
            v-model="errorDialog"
            max-width="320"
          >
            <v-card>
              <p class="text-center pa-4">
                Nastala chyba při odesílání kontaktního formuláře.
              </p>
              <v-btn
                type="submit"
                variant="flat"
                @click="errorDialog = false"
              >
                Pokračovat
              </v-btn>
            </v-card>
          </v-dialog>

          <v-form @submit.prevent="submitForm">
            <div class="default-text">
              <h3>Pošlete nám zprávu</h3>
              <p>Potřebujete poradit s projektem? …</p>
            </div>
            <v-text-field
              v-model="personalName"
              label="Jméno"
              variant="underlined"
              :error-messages="getViolation('personalName')"
            />
            <div class="grid-50-50">
              <v-text-field
                v-model="phone"
                label="Telefon"
                variant="underlined"
                :error-messages="getViolation('phone')"
              />
              <v-text-field
                v-model="emailAddress"
                label="E-mail"
                variant="underlined"
                :error-messages="getViolation('emailAddress')"
              />
            </div>
            <v-textarea
              v-model="message"
              label="Zpráva"
              variant="underlined"
              rows="7"
              :error-messages="getViolation('message')"
            />

            <!-- show any recaptcha error -->
            <div
              v-if="getViolation('recaptcha_token')"
              class="my-4 text-red"
            >
              {{ getViolation('recaptcha_token') }}
            </div>

            <div>
              <v-btn
                type="submit"
                variant="flat"
                size="x-large"
                :loading="loading"
                :disabled="loading"
              >
                Odeslat zprávu
              </v-btn>
            </div>
          </v-form>
          <article class="default-text">
            <h3>Nevíte, jak to popsat?</h3>
            <p>Je pro Vás zpráva příliš limitující? Zavolejte nám.<br>Nedovolali jste se? Je možné že jsme zrovna na dílně, my se ozveme!</p>
            <ul>
              <li>
                <p><a href="tel:00420776889446">+420 776 889 446</a></p>
              </li>
            </ul>
            <h3>Kontaktní údaje</h3>
            <ul>
              <li>
                <p>
                  <a
                    href="https://www.google.com/maps/place/Lhoteck%C3%A1+235,+277+14+D%C5%99%C3%ADsy/@50.2511903,14.6428747,17z"
                    target="_blank"
                    rel="noreferrer"
                  >Lhotecká 235<br>277 14 Dřísy</a>
                </p>
              </li>
              <li>
                <p>IČO: 28203925<br>DIČ: CZ28203925</p>
              </li>
            </ul>
            <h3>Když ani slova nestačí</h3>
            <p>Pokud ani slova nestačí, zastavte se u nás na dílně, a nakreslíme si to - po telefonické domluvě.</p>
            <ul>
              <li>
                <p>
                  <a
                    href="https://www.google.com/maps/place/Lhoteck%C3%A1+235,+277+14+D%C5%99%C3%ADsy/@50.2511903,14.6428747,17z"
                    target="_blank"
                    rel="noreferrer"
                  >Lhotecká 235<br>277 14 Dřísy</a>
                </p>
              </li>
            </ul>
          </article>
        </div>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2551.209355780112!2d14.6442571776913!3d50.25067407155464!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x470beff7c0d67d53%3A0xbb241981ca62d381!2zRMWZw61zeSAyMzUsIDI3NyAxNCBExZnDrXN5!5e0!3m2!1scs!2scz!4v1747067900654!5m2!1scs!2scz"
          loading="lazy"
          title="mapa"
        />
      </div>
    </section>
  </main>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'

import 'glightbox/dist/css/glightbox.css'
import { useErrorHandler } from '../composables/useErrorHandler'
import Axios from '../ajax'
import Qs from 'qs'
import VSectionReference from '../components/VSectionReference.vue'

interface RawMedia {
  id: number
  contentUrl: string
  description: string
}

interface GalleryGroup {
  galleryId: number
  media: RawMedia[]
}

type GalleryCategory = 'metal' | 'wood' | 'garden' | 'other'

const props = defineProps<{
  galleries: Record<GalleryCategory, GalleryGroup[]>
}>()

// --- Contact form ---
const { buildViolations, clearViolations, getViolation } = useErrorHandler()
const personalName = ref('')
const phone = ref('')
const emailAddress = ref('')
const message = ref('')
const loading = ref(false)
const successDialog = ref(false)
const errorDialog = ref(false)
const errorMessage = ref('')

const recaptchaSiteKey = '6Lem9SwrAAAAAB_iihxVzDe5O1rNZnc78GjkzNGo'
onMounted(() => {
  const scr = document.createElement('script')
  scr.src = `https://www.google.com/recaptcha/api.js?render=${recaptchaSiteKey}`
  document.head.appendChild(scr)
})

async function submitForm () {
  // A second click or Enter while reCAPTCHA or the request runs would send a duplicate inquiry.
  if (loading.value) return
  clearViolations()
  loading.value = true
  let token = ''
  try {
    token = await (window as any).grecaptcha.execute(recaptchaSiteKey, { action: 'submit' })
  } catch {
    // server will catch missing token
  }

  try {
    await Axios.post(
      '/kontakt.json',
      Qs.stringify({
        personalName: personalName.value,
        phone: phone.value,
        emailAddress: emailAddress.value,
        message: message.value,
        recaptcha_token: token
      })
    )
    personalName.value = phone.value = emailAddress.value = message.value = ''
    successDialog.value = true
  } catch (err: any) {
    buildViolations(err.response)
    errorMessage.value = err.response?.data?.message || 'Formulář nebyl odeslán. Zkuste to prosím znovu.'
    errorDialog.value = true
  } finally {
    loading.value = false
  }
}
</script>
